import { createAction } from '@reduxjs/toolkit';

export const addCookieConsent = createAction('cookieconsent/add');
